/*

    Верхнее меню
*/

import { NavLink } from 'react-router-dom';


import './TopMenu.css';
import React, {useContext} from 'react';
import axios_sender from '../modules/axios_sender';
import isAllow from '../modules/rights.js';
import isnull, { isId } from '../modules/isnull.js';
import { GetGlobalClient, ClearGlobalClient } from '../modules/client.js';
import { GetGlobalAnimal, ClearGlobalAnimal } from '../modules/animal.js';
import { calculateSelected } from '../modules/workers'

import {ThemeContext} from "../ThemeContext.js";



class TopMenu extends React.Component {

  constructor(props, ref) {
    super(props, ref);  

    this.FillWorkersCount = this.FillWorkersCount.bind(this);     // привязка this к событию
    this.SelectedClient = this.SelectedClient.bind(this);         // привязка this к событию
    this.SelectedAnimal = this.SelectedAnimal.bind(this);         // привязка this к событию
    this.ClearSelectedAnimalClient = this.ClearSelectedAnimalClient.bind(this);         // привязка this к событию
    this.ExitUser = this.ExitUser.bind(this);                     // привязка this к событию
        

    // отслеживаемые переменные
    this.state = {
        workers_count: 0,                       // кол-во врачей и ассистентов
        selected_client: GetGlobalClient(),     // выбранный клиент
        selected_animal: GetGlobalAnimal(),     // выбранное животное
        manipulation_itog: { cnt: 0, summa: 0}, // список выбранных манипуляций       
        
        aaa: this.context.valueContext,
    };

    //this.mp_list = [];

    this.state.workers_count = calculateSelected();   // выведем кол-во выделенных сотрудников

}

  static contextType = ThemeContext;


    componentDidMount()
    {
        console.log("---");
    }


    GetDoctors ()
    {
        if(isAllow("doctor")) return <>
            <NavLink className="nb col" to="/doctors">
                <div className="container d-flex justify-content-end align-items-center doc-assist"> X { this.state.workers_count }</div>
            </NavLink>    
         </>
        return "";
    }
    GetAnimalClient()
    {
        if(isAllow("doctor"))
        {

          // выберем класс для отображения кнопки с клиентом/животным
          let cnca = "btnt row";
          if( isId(this.state.selected_client.ID) == false ) cnca += " no-select-client";
          else if( isId(this.state.selected_animal.ID) == false ) cnca += " no-select-animal";

          return <>
            <div className={ cnca }>              

                  <NavLink className="nb col clients" to="/Clients">
                      <div className="clients"></div>
                  </NavLink>
                  
                  <div className="col-9">
                        <div className="client-info">{ this.state.selected_client.name }</div>
                        <div className="animal-info">
                            { this.state.selected_animal.animal_type.label }&nbsp;
                            <strong>{ this.state.selected_animal.animal_name }</strong>
                        </div>
                  </div>
                  <div className="col-1 clear-client" onClick={ this.ClearSelectedAnimalClient }></div>
            </div>        
          </>
        }

        return "";
    }
    Manipulation()
    {
        return <>
            <NavLink className="nb col" to="/manipulation">
                  <div className="btnt-sm manipulation"></div>
            </NavLink>
         </>
    }

    // табличка с выбранными манипуляциями
    SelectedManipulations()
    {
      let cnt = 0;
      if(!isnull(this.state.aaa.mp_list)) cnt = this.state.aaa.mp_list.length;
        
        return <>
            <NavLink className="nb col" to="/checkItog">
                  <div className="btnt-mp">
                      <div> { this.state.manipulation_itog.cnt } </div>
                      <div className="itog-price"> { this.state.manipulation_itog.summa } {cnt}</div>
                  </div>
            </NavLink>
         </>
    }

    

    render() {      
      return (
          <div className="TopMenu row">      
          { this.GetDoctors() }
          { this.GetAnimalClient() }      
          { this.Manipulation() }

          { this.SelectedManipulations() }
          
          { localStorage.getItem('id_user')>0 &&
          
            <div className="col-1 Exit container d-flex justify-content-center align-items-center">
              <span className="UserName"> { localStorage.getItem('user_name').substring(0, 3) } </span>
              <button className="UserNameExit" onClick={ this.ExitUser } title="Выход"></button>          
            </div>
          }
                
        </div>    
    );
  }

  ExitUser()
  {    
    this.props.onOutAuthorize(false);
    axios_sender({form: 'exit', }, this.ExitUserSuccess);
    localStorage.clear('id_user');
    localStorage.clear('user_name');
    localStorage.clear('token');

  }
  ExitUserSuccess(){}


  // функция будет вызвана из вне, чтобы заполнить кол-во работников
  FillWorkersCount(data) { this.setState({ workers_count: data }); }

  // функция будет вызвана из вне, чтобы заполнить имя клиента
  SelectedClient(client) { this.setState({ selected_client: client }); }
  // функция будет вызвана из вне, чтобы заполнить имя клиента
  SelectedAnimal(animal) { this.setState({ selected_animal: animal }); }

  // функция будет вызвана из вне, чтобы добавить выбранную услугу/товар
  AddManipulation(mp)
  {    
    this.mp_list.push(mp);
    let cnt = 0, summa = 0;
    for(var i in this.mp_list)
    {
        let m = this.mp_list[i];
        cnt += m.qty;
        summa += m.price * m.qty;
    }
    this.setState({ manipulation_itog: { cnt: cnt, summa: summa} });
  }

  // очистить выбранных клиента и животное
  ClearSelectedAnimalClient()
  {
      ClearGlobalAnimal();
      ClearGlobalClient();
      this.setState({ selected_client: [], selected_animal: { animal_type:[], animal_sex:[] } });
  }

}



export default TopMenu;
